// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/cloud/telemetry_read_api/h2ogpte/v1/h2ogpte.proto (package ai.h2o.cloud.telemetry_read_api.h2ogpte.v1, syntax proto3)
/* eslint-disable */

import type { Granularity } from "../../v1/aiunits_pb";
import type { Interval } from "../../../../../../google/type/interval_pb";
import type { BigIntString } from "../../../../../../runtime";
import { RPC } from "../../../../../../runtime";

/**
 * @generated from enum ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.Grouping
 */
export enum Grouping {
/**
 * ie, total
 *
 * @generated from enum value: GROUPING_UNSPECIFIED = 0;
 */
GROUPING_UNSPECIFIED = "GROUPING_UNSPECIFIED",

/**
 * @generated from enum value: WORKSPACE = 1;
 */
WORKSPACE = "WORKSPACE",

/**
 * @generated from enum value: USER = 2;
 */
USER = "USER",

/**
 * @generated from enum value: MODEL = 4;
 */
MODEL = "MODEL",

/**
 * @generated from enum value: EVENT_SOURCE = 5;
 */
EVENT_SOURCE = "EVENT_SOURCE",
}
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.CalculateTokenUsageRequest
 */
export type CalculateTokenUsageRequest = {
/**
 * The start time of interval which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp start_time = 1;
 */
startTime: string;
/**
 * The end time of interval which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp end_time = 2;
 */
endTime: string;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Granularity granularity = 3;
 */
granularity: Granularity;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.Grouping group_by = 4;
 */
groupBy: Grouping;
/**
 * When used, server will only calculate usage of resources that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160) specification.
 *
 * Supported fields:
 *   * workspace
 *   * user
 *   * model
 *   * event_source
 *
 * Examples:
 * workspace = 'my_workspace' AND user = 'test_user'
 * (workspace = 'my_workspace_1' OR workspace = 'my_workspace_2') AND user = 'test_user'
 *
 * @generated from field: string filter = 5;
 */
filter?: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 6;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 7;
 */
pageToken?: string;
/**
 * When used, server will return usage_breakdown for each interval ordered by the specified field.
 * Only one field will be supported once. No secondary ordering is supported.
 * Supported fields are input_tokens, output_tokens, total_tokens.
 * Default ordering will be in descending order for any field. i.e "input_tokens" == "input_tokens DESC"
 * Default will be "total_tokens DESC" if not set.
 * Ex: "input_tokens ASC", "output_tokens"
 *
 * @generated from field: string order_by = 8;
 */
orderBy?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.CalculateTokenUsageResponse
 */
export type CalculateTokenUsageResponse = {
/**
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsageWithBreakdown usage = 1;
 */
usage?: TokenUsageWithBreakdown[];
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.Grouping grouped_by = 2;
 */
groupedBy?: Grouping;
/**
 * @generated from field: string next_page_token = 3;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsageWithBreakdown
 */
export type TokenUsageWithBreakdown = {
/**
 * @generated from field: google.type.Interval interval = 1;
 */
interval?: Interval;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsage total_usage = 2;
 */
totalUsage?: TokenUsage;
/**
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsageBreakdown usage_breakdown = 3;
 */
usageBreakdown?: TokenUsageBreakdown[];
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsageBreakdown
 */
export type TokenUsageBreakdown = {
/**
 * @generated from field: string group = 1;
 */
group?: string;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsage usage = 2;
 */
usage?: TokenUsage;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.TokenUsage
 */
export type TokenUsage = {
/**
 * @generated from field: int64 input_tokens = 1;
 */
inputTokens?: BigIntString;
/**
 * @generated from field: int64 output_tokens = 2;
 */
outputTokens?: BigIntString;
}
;
/**
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.h2ogpte.v1.H2OGPTeService.CalculateTokenUsage
 */
export const H2OGPTeService_CalculateTokenUsage = new RPC<CalculateTokenUsageRequest,CalculateTokenUsageResponse>("GET", "/v1/h2ogpte/tokenUsage:calculate");
